import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Typography } from "@mui/material";

/**
 * Structural shape rather than a query-derived type, so the detail view's full
 * query and the stepper's slimmer step query both satisfy it without casts.
 * Accepts either a reviewer row (name under `user`) or a bare user.
 */
export type ReviewerSignerPerson = {
  email?: string | null;
  person?: { first?: string | null; last?: string | null } | null;
  user?: {
    email?: string | null;
    person?: { first?: string | null; last?: string | null } | null;
  } | null;
};

/**
 * One reviewer or signer with a status icon: a green check once approved, a red
 * close once rejected, and an amber clock while still outstanding.
 */
export function ReviewerSignerDisplay({
  person,
  isCompleted = false,
  approved = false,
}: {
  person: ReviewerSignerPerson;
  isCompleted?: boolean;
  approved?: boolean;
}) {
  const user = person.user || person;
  const personData = user.person;
  const displayName = personData ? `${personData.first || ""} ${personData.last || ""}`.trim() : "";
  const finalDisplay = displayName || user.email || "Unknown";
  const email = user.email;

  let icon = <AccessTimeIcon sx={{ color: "warning.main", fontSize: 20 }} />;
  if (isCompleted && approved) {
    icon = <CheckIcon sx={{ color: "success.main", fontSize: 20 }} />;
  } else if (isCompleted) {
    icon = <CloseIcon sx={{ color: "error.main", fontSize: 20 }} />;
  }

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      {icon}
      <Typography variant="body1">
        {displayName && email ? `${displayName}, ${email}` : finalDisplay}
      </Typography>
    </Box>
  );
}
